// 애니메이션 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import { Animated } from 'react-native';

// =================================================================================================
// 상수
// =================================================================================================
// 시간이 지남에 따라 값에 애니메이션을 적용 간소화
const timing = (animatedValue, toValue, durationSec) => {
  return Animated.timing(
    // 시간이 지남에 따라 값에 애니메이션을 적용
    animatedValue, // value
    {
      toValue: toValue,
      duration: 1000 * durationSec, // 애니메이션의 길이
      useNativeDriver: true, //  true일 때 네이티브 드라이버를 사용
    }, // config
  );
};

// 애니메이션 배열을 동시에 시작
const parallel = (animationList) => {
  return Animated.parallel(
    // 애니메이션 배열을 동시에 시작
    animationList,
    {}, // config
  );
};

// 애니메이션을 순서대로 시작. 다음 애니메이션을 시작하기 전에 각 애니메이션이 완료 될 때까지 기다림.
const sequence = (animationList) => {
  return Animated.sequence(
    // 애니메이션 배열을 동시에 시작
    animationList,
  );
};

// 애니메이션 반복
const loop = (compositeAnimation, count) => {
  return Animated.loop(
    // 애니메이션 배열을 동시에 시작
    compositeAnimation,
    {
      iterations: count, // 반복 횟수 [n: n회, -1: 무한]
      // resetBeforeIteration: true,
    }, // config
  );
};

// 애니메이션 시작 [완료 후 콜백 반환]
const start = (compositeAnimation) => {
  return compositeAnimation.start(); // 애니메이션 시작 [완료 후 콜백 반환]
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  timing,
  parallel,
  sequence,
  loop,
  start,
};
